import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EntitlementService } from '../services/evergent/entitlement/entitlement.service';
import { AuthService } from '../services/auth/auth.service';
import { AccountProfileService } from '../services/evergent/account/account-profile.service';
import { from } from 'rxjs';
import { ContentEntitlementService } from '../services/evergent/entitlement/content-entitlement.service';
import { DataService } from 'src/app/data.service';
import { PageType } from 'src/app/analytics/newrelic/enums/PageType';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { KEYS } from '../utils/constants/storage.constants';

@Injectable()
export class CoreResolver implements Resolve<any> {
  constructor(
    private accountProfileService: AccountProfileService,
    private entitlementService: EntitlementService,
    private authService: AuthService,
    private contentEntlmntService: ContentEntitlementService,
    private dataService: DataService,
    private router: Router,
    private readonly localStorage: LocalStorageService
  ) {}

  async resolve(route: ActivatedRouteSnapshot) {
    try {
      const isDeeplink =
        !!this.dataService.getPendingDeeplinkUrl ||
        !!this.dataService.isFromDeeplink;
      const isFreshLaunch =
        this.localStorage.getItem(KEYS.FRESH_LAUNCH) === 'true';

      if (
        route.params.id === this.dataService.homeTab ||
        route.data.pageID === PageType.MyAha ||
        route.data.pageID === PageType.Details ||
        route.data.pageID === PageType.Player ||
        route.data.isStorefrontTv ||
        isDeeplink ||
        isFreshLaunch
      ) {
        if (route.data.fetchVodCatlog) {
          this.entitlementService.tvodCatalogs();
        }
        if (this.authService.isLoggedIn()) {
          if (route.data.fetchVodEntitlements) {
            this.contentEntlmntService.fetchVodEntitlements();
          }
          if (route.data.fetchProfiles) {
            await this.accountProfileService.initializeAccountAndProfiles();
            if (!this.dataService.skipPreferredLanguageSelection) {
              return from(
                Promise.resolve(
                  this.router.navigate(['/new-preferred-language-selection'])
                )
              );
            }
          }
          if (route.data.fetchEntitlements) {
            await this.entitlementService.fetchEntitlements();
          }
        }
      }
    } catch (error) {
      console.error('CoreResolver error:', error);
    }
    return true;
  }
}
